// extracted by mini-css-extract-plugin
export default {"listItem":"mvrzI","header":"I_HLh","headerDate":"epaQa","headerArrow":"qCBmS","content":"nmtAw","actionButtons":"bu4XU","changesList":"JbZlS","noChanges":"Jyjp4"};